const mockExams = {
  mockExam: "Probe-Test",
  mockExams: "Probetests",
  mockExamsImport: "Probetests importieren",
  creation: "Probetest erstellen",
  update: "Probetest bearbeiten",
  creationInstruction: "Probetest-Einstellungen",
  noExerciseInMockExam:
    "Diesem Probetest wurden noch keine Übungen hinzugefügt.",
  mockExamsExplanation:
    "Probetests sind Aufgaben, die nur einmal durchgeführt werden, mit identischen Übungen und Fragen für alle Schüler.",
  badColumnsErrors:
    "Falsche Spaltenüberschriften. Erwartet: UUID, Theme, Level, Number, Name.",
  mockExamsFinding:
    "Der Probetest erscheint auf der Seite „Meine Aufgaben verfolgen“.",
  isAMockTestWarning:
    "Dies ist ein Probetest. Er kann nur einmal durchgeführt werden.",
  startMockTest: "Probetest starten",
  assignMockTest: "Probetest zuweisen",
  viewTest: "Schülerabgabe anzeigen",
  copyOf: "Abgabe von {name}",
  view: "Probetest-Vorschau",
};

export default mockExams;
